import { Container, Typography, Box, Card, CardContent } from '@mui/joy';
import { Link } from 'react-router-dom';
import { ArrowLeft } from '@phosphor-icons/react';
import { AppBasic } from '../../../components/app/App';

const documents = [
    {
        title: "Политика конфиденциальности",
        to: "/legal/privacy",
    },
    {
        title: "Условия использования",
        to: "/legal/terms-of-service",
    },
    {
        title: "Согласие на обработку персональных данных",
        to: "/legal/data-processing",
    },
    {
        title: "Политика использования cookie",
        to: "/legal/cookies",
    },
];

export default function PageSupport() {
    return (
        <AppBasic
            title="Поддержка"
            desc="Поддержка мессенджера Аквариум: напишите нам на почту, если у вас возникли вопросы или проблемы."
        >
        <Container
            maxWidth="xs"
            sx={{
                minHeight: '100dvh',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                py: { xs: 5, md: 8 },
            }}
        >
            <Link to="/" style={{ textDecoration: 'none', justifyContent: 'center', display: 'flex' }}>
                <Typography
                    startDecorator={<ArrowLeft size={20} />}
                    level="body-md"
                    sx={{ mb: 4, display: 'inline-flex', alignItems: 'center', gap: .5, '&:hover': { color: 'primary.plainColor' } }}
                >
                    На главную
                </Typography>
            </Link>

            <Box sx={{ textAlign: 'center', mb: 4 }}>
                <Typography level="h1" sx={{ mb: 2 }}>
                    Поддержка
                </Typography>
                <Typography level="body-md" sx={{ color: 'text.tertiary', maxWidth: 520, mx: 'auto' }}>
                    Есть вопросы или проблемы? Напишите нам на почту
                </Typography>
            </Box>

            <Box
                sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                className="cards-group"
            >
                <Card
                    component={Link}
                    to="mailto:daniil@dybka.ru"
                    sx={{
                        textDecoration: 'none !important',
                        border: 'none',
                        borderRadius: '100px',
                        transition: 'opacity .25s',

                        '.cards-group:has(&:hover) &:not(:hover)': {
                            opacity: 0.4,
                        },
                    }}
                >
                    <CardContent orientation="horizontal" sx={{ alignItems: 'center' }}>
                        <Box sx={{ flex: 1 }}>
                            <Typography level="title-lg" sx={{ textAlign: 'center' }}>
                                daniil@dybka.ru
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            </Box>
        </Container>
        </AppBasic>
    );
}
